import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { handleActions } from 'redux-actions';
import { reduxKey, DEFAULT_PUSH_SUBSCRIPTIONS } from './constants';
import { initPushSubscriptionsSuccess, setPushSubscriptionState, updatePushSubscriptions } from './actions';
import { PushSubscriptionState } from './types';
const defaultState = {
    pushSubscriptionState: PushSubscriptionState.LOADING,
    send: DEFAULT_PUSH_SUBSCRIPTIONS,
    initialized: false
};
const actionHandlers = handleActions({
    [setPushSubscriptionState.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            pushSubscriptionState: payload.newState
        }),
    [initPushSubscriptionsSuccess.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            initialized: true,
            send: _object_spread({}, state.send, payload)
        }),
    [updatePushSubscriptions.toString()]: (state, { payload })=>_object_spread_props(_object_spread({}, state), {
            send: _object_spread({}, state.send, payload)
        })
}, defaultState);
const reducers = {
    [reduxKey]: actionHandlers
};
export default reducers;

//# sourceMappingURL=reducers.js.map